import React from 'react'
import Link from 'next/link'
import { useDispatch } from 'react-redux'

import { clickLogoHeader } from 'client/contexts/Tracking/events'
import { sendTrackingRequestAction } from 'client/contexts/Tracking/actions'

import LogoBrand from '../LogoBrand'
import LogoVipDistrict from '../LogoVipDistsrict'
import LogoHappypal from '../LogoHappypal'
import LogoInspiring from '../LogoInspiring'

import { useBusiness } from 'src/hooks/useBusiness'
import {
  AFFILIATE_EBOOKING,
  AFFILIATE_VIPDISTRICT,
  AFFILIATE_HAPPYPAL,
  AFFILIATE_INSPIRING,
} from 'src/constants/affiliates'
import { EbookingLogo } from '../EbookingLogo'
import { EbookingLink } from '../EbookingLink'
import styles from './styles.module.css'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'
import { useRouter } from 'next/router'
import { Button } from '@s4l/ds'
import { IconArrowLeft } from '@s4l/icons/IconArrowLeft'

interface IHeaderLogoProps {
  backButton?: boolean
  pageId?: string | number
  isPrime?: boolean
  children?: React.ReactNode
}

const HeaderLogo = ({
  backButton = false,
  pageId,
  isPrime = false,
  children,
}: IHeaderLogoProps) => {
  const dispatch = useDispatch()
  const { affiliate } = useBusiness()
  const router = useRouter()

  const { sendEvent: sendClickHeaderBack } = useKafkaEvent({
    page: `${pageId}`,
    eventName: 'header_back',
  })

  const handleClickBack = () => {
    sendClickHeaderBack({ section: SECTIONS.HEADER })
    router.back()
  }

  function handleClick() {
    dispatch(sendTrackingRequestAction({ event: clickLogoHeader() }))
  }

  function renderLogo() {
    if (affiliate === AFFILIATE_EBOOKING) {
      return (
        <EbookingLink>
          <EbookingLogo />
        </EbookingLink>
      )
    }

    const affiliateLogoConfig = {
      [AFFILIATE_VIPDISTRICT]: LogoVipDistrict,
      [AFFILIATE_HAPPYPAL]: LogoHappypal,
      [AFFILIATE_INSPIRING]: LogoInspiring,
    } as const

    const PartnerLogoComponent = affiliateLogoConfig[affiliate as keyof typeof affiliateLogoConfig]

    if (PartnerLogoComponent) {
      return (
        <Link href="/" data-testid={`logo-link-${pageId}`} onClick={handleClick}>
          <PartnerLogoComponent isResponsive />
        </Link>
      )
    }

    return (
      <Link href="/" data-testid={`logo-link-${pageId}`} onClick={handleClick}>
        <LogoBrand
          isPrime={isPrime}
          isPromo={process.env.NEXT_PUBLIC_IS_PROMO_LOGO_ENABLED === 'true'}
          isResponsive
        />
      </Link>
    )
  }

  return (
    <div className={styles.leftContainer}>
      {backButton && (
        <Button
          data-testid="arrow-back-button"
          variant="icon-rounded"
          size="small"
          leadingIcon={<IconArrowLeft />}
          onClick={handleClickBack}
        />
      )}
      {renderLogo()}
      {children}
    </div>
  )
}

export default HeaderLogo
